import { Tariff } from 'interfaces';
import { http, HttpResponse } from 'msw';
import { buildTariff } from '../../factories';
import { canonicalTariffs } from '../../factories/seeds/entities';

export const mockTariffs: Tariff[] = canonicalTariffs.map(
  (tariff) => buildTariff<Tariff>(tariff) as Tariff
);

export const tariffMockHandlers = [
  // mock for useListTariffs()
  http.get('https://*/resource/tariff/all', () => {
    return HttpResponse.json(mockTariffs);
  }),

  http.post('https://*/resource/tariff/bulk', async ({ request }) => {
    const body = (await request.json()) as {
      rateFile: string;
      descriptionFile: string;
    };
    return HttpResponse.json({
      jobId: '33333333-3333-4333-8333-333333333333',
      status: 'PENDING',
      rateFile: body.rateFile,
      descriptionFile: body.descriptionFile,
    });
  }),

  http.get('https://*/resource/tariff/bulk', ({ request }) => {
    const url = new URL(request.url);
    return HttpResponse.json({
      jobId:
        url.searchParams.get('jobId') ??
        '33333333-3333-4333-8333-333333333333',
      status: 'COMPLETED',
      rateFile: 'rates.txt',
      descriptionFile: 'descriptions.txt',
      result: {
        success: true,
        totalRows: 1,
        createdCount: 1,
        skippedCount: 0,
        failedCount: 0,
        updatedCount: 0,
        created: [
          {
            row: 1,
            tariff: '71234',
            prefix: 7,
            code: '1234',
            specialtyCode: 'ALL',
            effectiveDate: '2025-01-01',
            rate: '10.00',
          },
        ],
        skipped: [],
        failed: [],
      },
    });
  }),

  // mock for useGetTariff()
  http.get('https://*/resource/tariff', ({ request }) => {
    const url = new URL(request.url);
    const id = url.searchParams.get('id');
    const tariff = mockTariffs.find((tariff) => tariff.id === id);
    return HttpResponse.json(tariff);
  }),
];
